import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { GlobalSettings } from './global.settings';

@Injectable({
  providedIn: 'root'
})

export class ApplicationService {

  orgId:any;

  /**
   * Api data for api/v1/nodeTypes
   */
  nodeTypesData: any;

  /**
   * Api data for api/v1/language/list
   */
  languageListData: any;

  /**
   * Api data for api/v1/metadata/random_id?internal_name=Taxonomy%20Type
   */
  metadataTaxonomyTypeData: any;

  /**
   *  Api data for /metadata
   */
  metadataData: any;

  /**
   *  Api data for api/v1/taxonomy/list?document_list_type=1&document_list_type=2
   */
  taxonomyDocumentTypeListData: any;

  /**
   *  Api data for api/v1/taxonomy/list
   */
  taxonomyListData: any;

  /**
   *  Api data for api/v1/caseAssociation/listTypes?type=all
   */
  caseAssociationTypeAllData: any;

  /**
   *  Api data for /api/v1/projects?project_type=1
   */
  projectTypeList: any;

  /**
   *  Api data for  api data for api/v1/users
   */
  usersList: any;

  /**
   *  Api data for api/v1/workflows
   */
  workflowList: any;

  // api data project Details
  projectDetailsList: any;

  constructor(private service: CommonService)
  {}

  /**
   * Get Application service data
   *
   * @param performUpdate (whether to call API and fetch the data again)
   * @param dataType (which type of api data we need to fetch that is name of API)
   * @param queryParam (query parameters if any that is required by the API)
   *
   * @returns (return the API data if not exist then call the api and if exist then return same)
   */
  public getApplicationServiceData(performUpdate, dataType, queryParam?, viewLocation?) {
    const parameters = queryParam ? queryParam : '';
    const org_id = localStorage.getItem('orgDetails')
      ? JSON.parse(localStorage.getItem('orgDetails'))['orgId']
      : '';
    const frontFaceParams = '?organization_id=' + org_id + '&front_facing=true';
    const url = (viewLocation == 'front-facing')
      ? this.getServiceUrl(dataType) + frontFaceParams 
      : this.getServiceUrl(dataType) + parameters;

    return new Promise(async (resolve, reject) => {
      try {
        if (performUpdate) {
          const applicationServiceData = await this.callApplicationService(url, dataType);
          return resolve(applicationServiceData);
        } else {
          const data = await this.checkApplicationDataExist(dataType, url);
          return resolve(data);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  /**
   * Call Application Service
   *
   * @param url (api url)
   * @param dataType (which type of api data we need to fetch that is name of API)
   *
   * @returns (return the API data if not exist then call the api and if exist then return same)
   */
  public callApplicationService(url, dataType) {
    return new Promise((resolve, reject) => {
      this.service.getServiceData(url).then(async (res: any) => {
        await this.setApplicationServiceTypeData(dataType, res);
        return resolve(res);
      }).catch((err: any) => {
        this.setApplicationServiceTypeData(dataType, err);
        return resolve({});
      });
    });
  }

  /**
   * Set Application Service Type data
   *
   * @param dataType (which type of api data we need to fetch that is name of API)
   * @param applicationServiceData (api data)
   *
   * @returns (return the API data if not exist then call the api and if exist then return same)
   */
  public setApplicationServiceTypeData(dataType, applicationServiceData) {
    return new Promise((resolve, reject) => {
      switch (dataType) {

        case 'nodeTypeList':
          this.nodeTypesData = applicationServiceData;
          resolve(this.nodeTypesData);
          break;

        case 'languageList':
          this.languageListData = applicationServiceData;
          resolve(this.languageListData);
          break;

        case 'taxonomyTypeMetatadata':
          this.metadataTaxonomyTypeData = applicationServiceData;
          resolve(this.metadataTaxonomyTypeData);
          break;

        case 'metatadataList':
          this.metadataData = applicationServiceData;
          resolve(this.metadataData);
          break;

        case 'taxonomyTypeList':
          this.taxonomyListData = applicationServiceData;
          resolve(this.taxonomyListData);
          break;

        case 'documentListType':
          this.taxonomyDocumentTypeListData = applicationServiceData;
          resolve(this.taxonomyDocumentTypeListData);
          break;

        case 'associationTypeAll':
          this.caseAssociationTypeAllData = applicationServiceData;
          resolve(this.caseAssociationTypeAllData);
          break;

        case 'projectTypeList':
          this.projectTypeList = applicationServiceData;
          resolve(this.projectTypeList);
          break;

        case 'projectDetailsList':
          this.projectDetailsList = applicationServiceData;
          resolve(this.projectDetailsList);
          break;

        case 'usersList':
          this.usersList = applicationServiceData;
          resolve(this.usersList);
          break;

        case 'workflowList':
          this.workflowList = applicationServiceData;
          resolve(this.workflowList);
          break;
      }
    });
  }

  /**
   * Check application data exists
   *
   * @param dataType (which type of api data we need to fetch that is name of API)
   * @param url (api url)
   *
   * @returns (return the API data if not exist then call the api and if exist then return same)
   */
  public checkApplicationDataExist(dataType, url) {
    return new Promise(async (resolve, reject) => {
      switch (dataType) {
        case 'nodeTypeList':
          if (!this.nodeTypesData) {
            await this.callApplicationService(url, dataType);
          }
          resolve(this.nodeTypesData);
          break;

        case 'languageList':
          if (!this.languageListData) {
            await this.callApplicationService(url, dataType);
          }
          resolve(this.languageListData);
          break;

        case 'taxonomyTypeMetatadata':
          if (!this.metadataTaxonomyTypeData) {
            await this.callApplicationService(url, dataType);
          }
          resolve(this.metadataTaxonomyTypeData);
          break;

        case 'metatadataList':
          if (!this.metadataData) {
            await this.callApplicationService(url, dataType);
          }
          resolve(this.metadataData);
          break;

        case 'taxonomyTypeList':
          if (!this.taxonomyListData) {
            await this.callApplicationService(url, dataType);
          }
          resolve(this.taxonomyListData);
          break;

        case 'documentListType':
          if (!this.taxonomyDocumentTypeListData) {
            await this.callApplicationService(url, dataType);
          }
          resolve(this.taxonomyDocumentTypeListData);
          break;

        case 'associationTypeAll':
          if (!this.caseAssociationTypeAllData) {
            await this.callApplicationService(url, dataType);
          }
          resolve(this.caseAssociationTypeAllData);
          break;

        case 'projectTypeList':
          if (!this.projectTypeList) {
            await this.callApplicationService(url, dataType);
          }
          resolve(this.projectTypeList);
          break;

        case 'projectDetailsList':
          if (!this.projectDetailsList) {
            await this.callApplicationService(url, dataType);
          }
          resolve(this.projectDetailsList);
          break;

        case 'usersList':
          if (!this.usersList) {
            await this.callApplicationService(url, dataType);
          }
          resolve(this.usersList);
          break;

        case 'workflowList':
          if (!this.workflowList) {
            await this.callApplicationService(url, dataType);
          }
          resolve(this.workflowList);
          break;
      }
    });
  }

  /**
   * Get Service URLs
   *
   * @param dataType (which type of api data we need to fetch that is name of API)
   *
   * @returns (return the API data if not exist then call the api and if exist then return same)
   */
  public getServiceUrl(dataType) {
    let url = GlobalSettings.GET_NODETYPE_LIST;
    switch (dataType) {
      case 'nodeTypeList':
        url = GlobalSettings.GET_NODETYPE_LIST;
        break;

      case 'languageList':
        url = GlobalSettings.LANGUAGE_LIST;
        break;

      case 'taxonomyTypeMetatadata':
        url = GlobalSettings.GET_METADATA_LIST;
        break;

      case 'metatadataList':
        url = GlobalSettings.GET_METADATA_LIST;
        break;

      case 'taxonomyTypeList':
        url = GlobalSettings.TAXONOMY_LIST;
        break;

      case 'documentListType':
        url = GlobalSettings.TAXONOMY_LIST;
        break;

      case 'associationTypeAll':
        url = GlobalSettings.GET_CASE_ASSOCIATION_TYPES;
        break;

      case 'projectTypeList':
        url = GlobalSettings.PROJECT_LIST;
        break;

      case 'usersList':
        url = GlobalSettings.GET_USERS;
        break;

      case 'workflowList':
        url = GlobalSettings.WORKFLOW_LIST;
        break;

      case 'projectDetailsList':
        url = GlobalSettings.PROJECT_DETAILS;
        break;

    }
    return url;
  }

  /**
   * To get organization id from org code
   *
   * @param org_code uuid
   * @returns void
   */
  public getOrgId(org_code) {
    return new Promise((resolve, reject) => {
      const url = GlobalSettings.GET_ORGANIZATION_CODE + '/' + org_code;
      this.service.getUserServiceDataWithoutTocken(url).then((res: any) => {
        return resolve(res);
      }).catch((err: any) => {
        return resolve({});
      });
    });
  }
}